export default {
	title: 'Ses vaccins',
	aucunvaccin: 'Aucun vaccin à faire ce mois-ci.',
	mois1: {
		afaire: [
			{
				text: '<b>La vaccination constitue un moyen essentiel pour protéger votre enfant contre différentes maladies infectieuses graves et pour éviter que ces maladies se propagent dans la population. Au cours de ses 2 premières années votre enfant devra être vacciné contre 11 maladies</b> (la diphtérie, la coqueluche, le tétanos, la poliomyélite, les méningites à Haemophilus influenzae b, l’hépatite B, la rougeole, la rubéole, les oreillons, les infections à pneumocoque, les infections à méningocoque C).'
			},
			{
				text: 'L’administration des vaccins commence à l’âge de 2 mois mais il peut être nécessaire de faire vacciner votre enfant contre la tuberculose (BCG) dès maintenant. Demandez conseil à votre médecin.'
			}
		],
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: 'A ne pas manquer à 2 mois',
			paragraphe: [
				{
					text:'1ère injection de vaccins <ul><li>DTP (diphtérie, tétanos, poliomyélite)</li><li>HIB (Haemophilus influenzae de type b)</li><li>Coqueluche</li><li>Hépatite B</li><li>Pneumocoque</li></ul>',
					image:'vaccin.svg'
				}
			]
		}
	},
	mois2: {
		afaire: [
			{
				text: '1ère injection de vaccins <ul><li>DTP (diphtérie, tétanos, poliomyélite)</li><li>HIB (Haemophilus influenzae de type b)</li><li>Coqueluche</li><li>Hépatite B</li><li>Pneumocoque</li></ul>',
				image:'vaccin.svg'
			},
			{
				text: 'Vacciner votre enfant tôt lui permet d’être protégé avant d’être exposé à certaines maladies infectieuses dangereuses.'
			},
			{
				text: 'Les vaccinations peuvent être réalisées par votre médecin généraliste, votre pédiatre, une sage-femme en libéral ou en PMI.'
			},
			{
				text: 'Il existe des gestes simples pour préparer votre bébé à la vaccination : le rassurer en lui parlant doucement, le tenir assis sur ses genoux ou le porter dans les bras pour le mettre en confiance.'
			},
			{
				text: 'L’application locale préalable d’un patch anesthésiant qui réduit la douleur liée à la pénétration de l’aiguille peut aussi être proposée par votre médecin.'
			}
		],
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		]
	},
	mois3: {
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: 'A ne pas manquer à 4 mois',
			paragraphe: [
				{
					text:'2<sup>ème</sup> injection de vaccins <ul><li>DTP (diphtérie, tétanos, poliomyélite)</li><li>HIB (Haemophilus influenzae de type b)</li><li>Coqueluche</li><li>Hépatite B</li><li>Pneumocoque</li></ul>',
					image:'vaccin.svg'
				}
			]
		},
		aucunvaccin: {
			text:''
		}
	},
	mois4: {
		afaire: [
			{
				text: '2<sup>ème</sup> injection de vaccins <ul><li>DTP (diphtérie, tétanos, poliomyélite)</li><li>HIB (Haemophilus influenzae de type b)</li><li>Coqueluche</li><li>Hépatite B</li><li>Pneumocoque</li></ul>',
				image:'vaccin.svg'
			},
			{
				text: 'S’il est gardé en collectivité, il va côtoyer beaucoup d’autres enfants. La vaccination permet de le préserver du risque de contracter de nombreuses maladies infectieuses très contagieuses.'
			},
			{
				text: 'La vaccination de tous les enfants permet également de lutter contre les épidémies qui réapparaissent en France.'
			},
			{
				text: 'Un certificat de vaccination pourra vous être demandé lors de son entrée dans une collectivité, en crèche par exemple.'
			}
		],
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: 'A ne pas manquer à 5 mois',
			paragraphe: [
				{
					text:'Méningocoque C',
					image:'vaccin.svg'
				}
			]
		}
	},
	mois6: {
		afaire: [
			{
				text: 'Méningocoque C',
				image:'vaccin.svg'
			}
		],
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		]
	},
	mois8: {
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: 'A ne pas manquer à 11 mois',
			paragraphe: [
				{
					text:'3<sup>ème</sup> injection de vaccins <ul><li>DTP (diphtérie, tétanos, poliomyélite)</li><li>HIB (Haemophilus influenzae de type b)</li><li>Coqueluche</li><li>Hépatite B</li><li>Pneumocoque</li></ul>',
					image:'vaccin.svg'
				}
			]
		},
		aucunvaccin: {
			text:'La durée de la protection acquise varie selon les vaccins (quantité d\'antigènes présente dans le vaccin, mode de préparation), c\'est pourquoi il est nécessaire dans certains cas de pratiquer plusieurs injections et des rappels pour obtenir une protection maximale.'
		}
	},
	mois11: {
		afaire: [
			{
				text:'3<sup>ème</sup> injection de vaccins <ul><li>DTP (diphtérie, tétanos, poliomyélite)</li><li>HIB (Haemophilus influenzae de type b)</li><li>Coqueluche</li><li>Hépatite B</li><li>Pneumocoque</li></ul>',
				image:'vaccin.svg'
			},
			{
				text:'La vaccination permet de le protéger mais aussi de protéger les autres enfants. La quasi disparition en France de la plupart des maladies est d’ailleurs liée à la vaccination. Leur réapparition pourrait avoir lieu si l’on arrêtait de vacciner.'
			}
		],
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: 'A ne pas manquer à 12 mois',
			paragraphe: [
				{
					text:'Méningocoque C',
					image:'vaccin.svg'
				},
				{
					text:'ROR (rougeole, oreillons et rubéole)',
					image:'vaccin.svg'
				}
			]
		}
	},
	mois12: {
		afaire: [
			{
				text:'Méningocoque C',
				image:'vaccin.svg'
			},
			{
				text:'ROR (rougeole, oreillons et rubéole)',
				image:'vaccin.svg'
			}
		],
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		]
	},
	mois15: {
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: 'A ne pas manquer entre 16 et 18 mois',
			paragraphe: [
				{
					text:'Seconde dose de vaccin ROR (rougeole, oreillons et rubéole)',
					image:'vaccin.svg'
				}
			]
		},
		aucunvaccin: {
			text:'Votre enfant a déjà été vacciné plusieurs fois. Les vaccins qui lui ont déjà été administrés et la date de sa prochaine vaccination sont inscrits dans son carnet de santé. En cas de retard demandez conseil à votre médecin.'
		}
	},
	mois18: {
		afaire: [
			{
				text:'Seconde dose de vaccin ROR (rougeole, oreillons et rubéole)',
				image:'vaccin.svg'
			},
			{
				text:'L’élimination de la rougeole est possible si 95% des enfants sont vaccinés avec 2 doses de vaccin ROR avant l’âge de 18 mois.'
			}
		],
		voyage: {
			title: 'En cas de voyage',
			text: 'Certaines vaccinations spécifiques sont recommandées en fonction de la destination de votre voyage. Demander conseil à votre médecin.'
		},
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: '',
			paragraphe: [
				{
					text:'<b>Son prochain rappel aura lieu à 6 ans</b> contre la diphtérie, la coqueluche, le tétanos et la poliomyélite.'
				}
			]
		}
	},
	mois23: {
		voyage: {
			title: 'En cas de voyage',
			text: 'Certaines vaccinations spécifiques sont recommandées en fonction de la destination de votre voyage. Demander conseil à votre médecin.'
		},
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: '',
			paragraphe: [
				{
					text:'<b>Son prochain rappel aura lieu à 6 ans</b> contre la diphtérie, la coqueluche, le tétanos et la poliomyélite.'
				}
			]
		},
		aucunvaccin: {
			text:'Votre enfant a déjà été vacciné plusieurs fois. Les vaccins qui lui ont déjà été administrés et la date de sa prochaine vaccination sont inscrits dans son carnet de santé. En cas de retard demandez conseil à votre médecin.'
		}
	},
	mois24: {
		voyage: {
			title: 'En cas de voyage',
			text: 'Certaines vaccinations spécifiques sont recommandées en fonction de la destination de votre voyage. Demander conseil à votre médecin.'
		},
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: '',
			paragraphe: [
				{
					text:'<b>Son prochain rappel aura lieu à 6 ans</b> contre la diphtérie, la coqueluche, le tétanos et la poliomyélite.'
				}
			]
		},
		aucunvaccin: {
			text:'A 2 ans, votre enfant a généralement reçu toutes ses vaccinations. Pour acquérir une immunité complète et durable, des rappels pour certains vaccins seront nécessaires au cours de sa vie.'}
	},
	mois36: {
		voyage: {
			title: 'En cas de voyage',
			text: 'Certaines vaccinations spécifiques sont recommandées en fonction de la destination de votre voyage. Demander conseil à votre médecin.'
		},
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: '',
			paragraphe: [
				{
					text:'<b>Son prochain rappel aura lieu à 6 ans</b> contre la diphtérie, la coqueluche, le tétanos et la poliomyélite.'
				}
			]
		},
		aucunvaccin: {
			text:'A l’école, votre enfant va côtoyer beaucoup d’autres enfants. La vaccination permet de le préserver d’un risque élevé de contracter de nombreuses maladies infectieuses très contagieuses, de protéger les autres enfants de la collectivité et de diminuer le risque d’épidémies. Un certificat de vaccination vous sera demandé lors son inscription à l’école.'}
	},
	mois48: {
		voyage: {
			title: 'En cas de voyage',
			text: 'Certaines vaccinations spécifiques sont recommandées en fonction de la destination de votre voyage. Demander conseil à votre médecin.'
		},
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: '',
			paragraphe: [
				{
					text:'<b>Son prochain rappel aura lieu à 6 ans</b> contre la diphtérie, la coqueluche, le tétanos et la poliomyélite.'
				}
			]
		},
		aucunvaccin: {
			text:'Si un retard est intervenu dans la réalisation d’un rappel de certains vaccins, il n’est pas nécessaire de tout recommencer. Il suffit de reprendre la vaccination au stade où elle a été interrompue et de la compléter en réalisant le nombre d’injections requis en fonction de l’âge. Demandez conseil à votre médecin.'}
	},
	mois60: {
		voyage: {
			title: 'En cas de voyage',
			text: 'Certaines vaccinations spécifiques sont recommandées en fonction de la destination de votre voyage. Demander conseil à votre médecin.'
		},
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: 'A ne pas manquer à 6 ans',
			paragraphe: [
				{
					text:'Rappel de vaccination DTP (diphtérie, la coqueluche, le tétanos, et la poliomyélite)',
					image:'vaccin.svg'
				}
			]
		},
		aucunvaccin: {
			text:'Si un retard est intervenu dans la réalisation d’un rappel de certains vaccins, il n’est pas nécessaire de tout recommencer. Il suffit de reprendre la vaccination au stade où elle a été interrompue et de la compléter en réalisant le nombre d’injections requis en fonction de l’âge. Demandez conseil à votre médecin.'}
	},
	mois84: {
		afaire: [
			{
				text:'Rappel de vaccination DTP (diphtérie, la coqueluche, le tétanos, et la poliomyélite)',
				image:'vaccin.svg'
			},
			{
				text:'Si un retard est intervenu dans la réalisation d’un rappel de certains vaccins, il n’est pas nécessaire de tout recommencer. Il suffit de reprendre la vaccination au stade où elle a été interrompue et de la compléter en réalisant le nombre d’injections requis en fonction de l’âge. Demandez conseil à votre médecin.'
			}
		],
		voyage: {
			title: 'En cas de voyage',
			text: 'Certaines vaccinations spécifiques sont recommandées en fonction de la destination de votre voyage. Demander conseil à votre médecin.'
		},
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: 'A ne pas manquer à 6 ans',
			paragraphe: [
				{
					text:'<b>Son prochain rappel aura lieu entre 11 et 13 ans</b> contre la diphtérie, la coqueluche, le tétanos et la poliomyélite.'
				}
			]
		}
	},
	mois108: {
		voyage: {
			title: 'En cas de voyage',
			text: 'Certaines vaccinations spécifiques sont recommandées en fonction de la destination de votre voyage. Demander conseil à votre médecin.'
		},
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		],
		prochainexamens: {
			title: 'A ne pas manquer entre 10 et 13 ans',
			paragraphe: [
				{
					text:'Rappel de vaccination <ul><li>DTP (diphtérie, tétanos, poliomyélite)</li><li>Coqueluche</li></ul>',
					image:'vaccin.svg'
				}
			]
		},
		aucunvaccin: {
			text:'Si un retard est intervenu dans la réalisation d’un rappel de certains vaccins, il n’est pas nécessaire de tout recommencer. Il suffit de reprendre la vaccination au stade où elle a été interrompue et de la compléter en réalisant le nombre d’injections requis en fonction de l’âge. Demandez conseil à votre médecin.'}
	},
	mois156: {
		afaire: [
			{
				text:'Rappel de vaccination <ul><li>DTP (diphtérie, tétanos, poliomyélite)</li><li>Coqueluche</li></ul>',
				image:'vaccin.svg'
			},
			{
				text:'<p>Vaccin contre les infections à papillomavirus humains (HPV)</p><p>Recommandé pour toutes les jeunes filles de 11 à 14 ans. Deux ou trois injections sont nécessaires en fonction du vaccin utilisé et de l’âge. Parlez-en avec votre médecin.</p>',
				image:'vaccin.svg'
			},
			{
				text:'Si un retard est intervenu dans la réalisation d’un rappel de certains vaccins, il n’est pas nécessaire de tout recommencer. Il suffit de reprendre la vaccination au stade où elle a été interrompue et de la compléter en réalisant le nombre d’injections requis en fonction de l’âge. Demandez conseil à votre médecin.'
			}
		],
		voyage: {
			title: 'En cas de voyage',
			text: 'Certaines vaccinations spécifiques sont recommandées en fonction de la destination de votre voyage. Demander conseil à votre médecin.'
		},
		liensutiles: [
			'calendriervaccinations','vaccinsobligatoires'
		]
	}
};
